import { messageError } from '../../../components/message';
import { log } from '../../../lib';
import getFormatMessage from '../../../locales/get-format-message';
import { IGameEnvModel } from '../../../model/api-modules/env';

export const initStudioFailedTip = (gameID: string, studioID?: string) => {
  const errorTip = getFormatMessage('request_fail_no_permission');
  messageError(errorTip);
  log().error(`${errorTip}. studio id: ${studioID}, game id: ${gameID}`);
};

export const initGameEnvFailedTip = (
  gameID: string,
  envs: ReadonlyArray<IGameEnvModel> | null
) => {
  const errorTip =
    envs === null
      ? getFormatMessage('request_fail_no_permission')
      : getFormatMessage('game_not_env_tips');
  messageError(errorTip);
  log().error(`${errorTip}. game id: ${gameID}`);
};
